import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation AddCompany($uuid: ID!, $company: CompanyDetailsInput!) {
    addCompany(uuid: $uuid, company: $company) {
      status
      stage
    }
  }
`
export const addCompanyKey = getQueryNames(mutation)[0]

export default mutation
